import { makeSendOtp, makeVerifyOtp } from '@/main/factories/modules/auth'
import { SignupPage } from '@/modules/auth/ui'

const sendOtp = makeSendOtp()
const verifyOtp = makeVerifyOtp()

export function SignupRoute() {
  return <SignupPage onSendOtp={sendOtp} onVerifyOtp={verifyOtp} />
}
